import React from 'react';

// react-snap prerenders with userAgent "ReactSnap", using an old bundled
// Chromium that can't parse modern syntax in Google's own maps embed script
// (maps.gstatic.com/.../init_embed.js) — it throws a page-level SyntaxError
// that crashes the whole prerender crawl. The map has nothing useful to
// contribute to a static snapshot anyway (address/phone are already plain
// text elsewhere on the page), so skip the iframe there entirely.
const isPrerender =
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const ContactMap = ({ lat, lng }) => {
  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);
  const mapSrc = `https://maps.google.com/maps?q=${latNum},${lngNum}&z=15&output=embed`;

  if (isNaN(latNum) || isNaN(lngNum)) return null;
  if (isPrerender) return null;

  return (
    <div className="contact-map-wrapper-dark">
      <iframe
        title="Office location"
        src={mapSrc}
        width="100%"
        height="400"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default ContactMap;
